import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  dedicatedNumberList: [],
}

export const getDedicatedNumberList: any = createAsyncThunk(
  '/getDedicatedNumberList',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}admin/getDedicatedNumber`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const createDedicatedNumberList: any = createAsyncThunk(
  '/createDedicatedNumberList',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .post(`${API_URL}admin/createDedicatedNumber`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => res.data.status == true && toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getDedicatedNumberList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const deleteDedicatedNumberList: any = createAsyncThunk(
  '/deleteDedicatedNumberList',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/deleteDedicatedNumber/${data?.id}`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const updateDedicatedNumberList: any = createAsyncThunk(
  '/updateDedicatedNumberList',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/updateDedicatedNumber/${data?._id}`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const bulkDedicatedImport: any = createAsyncThunk(
  '/bulkDedicatedImport',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .post(`${API_URL}admin/bulkImportDedicatedNumber`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => res?.data?.status == true && toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getDedicatedNumberList())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const DedicatedNumber = createSlice({
  name: 'DedicatedNumber',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [getDedicatedNumberList.fulfilled]: (state, {payload}) => {
      return {...state, dedicatedNumberList: payload.data}
    },
  },
})

export default DedicatedNumber.reducer
